// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"support-address_sectionContainer__Ot_6n","textWrapper":"support-address_textWrapper___wBOv"};